import { c as _c } from "react/compiler-runtime";
import { MAILING_DOUBLE_OPT_IN_SETTINGS_API } from 'modules/profile/mailing-settings/api/mailing-settings-double-opt-in-api';
import { MailingDoubleOptInSettingsInterface } from 'modules/profile/mailing-settings/types/mailing-settings-double-optin-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useOnceTrue } from 'shared/hooks/use-once-true';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
interface useMailingDoubleOptInInterface {
  shouldFetch: boolean;
}
export function useMailingDoubleOptIn(t0) {
  const $ = _c(6);
  const {
    shouldFetch
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const allowed = useOnceTrue(!!user && !!shouldFetch);
  let t2;
  if ($[1] !== allowed) {
    t2 = () => {
      if (allowed) {
        return MAILING_DOUBLE_OPT_IN_SETTINGS_API;
      }
      return null;
    };
    $[1] = allowed;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: mailingDoubleOptInSettings,
    mutate: mutateOptInSettings
  } = useSWR(t2, fetcher);
  let t3;
  if ($[3] !== mailingDoubleOptInSettings || $[4] !== mutateOptInSettings) {
    t3 = {
      mailingDoubleOptInSettings,
      mutateOptInSettings
    };
    $[3] = mailingDoubleOptInSettings;
    $[4] = mutateOptInSettings;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}